<section [cdkMenuTriggerFor]="c" class="relative">
    <app-input
        readonly
        [color]="currentColor()"
        [size]="currentSize()"
        [rounded]="currentRounded()"
        [required]="required()"
        [disabled]="disabled()"
        [autofocus]="autofocus()"
        [autocomplete]="autocomplete()"
        [spellcheck]="spellcheck()"
        [label]="label()"
        [(value)]="inputValue"
        (inputKeydown)="handleKeyDown($event)"
    >
        <app-icon
            (click)="handleOpenCalendar()"
            [attr.data-theme]="theme()"
            class="cursor-pointer theme-text"
            icons
            name="material-symbols:calendar-month"
        />
    </app-input>
    <!-- @if (isOpen()) {
        <div
            class="shadow-md md:min-w-max fixed md:inset-auto md:w-auto md:h-auto inset-0 items-center flex p-4 md:p-0 w-screen md:bg-transparent bg-black/70 h-screen z-[999] md:absolute md:right-1 md:top-[calc(100%+4px)]"
        >
            <app-input-calendar
                mode="range"
                [attr.data-theme]="theme()"
                [startDate]="start()"
                [endDate]="end()"
                (select)="handleSelect($event)"
            />
        </div>
    } -->
</section>

<ng-template #c>
    <div
        cdkMenu
        class="flex items-center w-screen h-screen p-4 shadow-md -0 md:min-w-max md:inset-auto md:w-auto md:h-auto md:p-0 md:bg-transparent bg-black/70"
    >
        <app-input-calendar
            mode="range"
            [attr.data-theme]="theme()"
            [startDate]="start()"
            [endDate]="end()"
            (select)="handleSelect($event)"
        />
    </div>
</ng-template>
